import { getFullName } from "shared/utils";
import { TicketPurchaseConfirmationPropTypes } from "./types";
import { useTicketPurchaseConfirmationService } from "./service";
import { PurchaseConfirmation } from "shared/components/purchaseOrder";
import { ConfirmationPageEntityType } from "shared/components/purchaseOrder/components/enum";

export default function TicketPurchaseConfirmation(props: TicketPurchaseConfirmationPropTypes) {
  const service = useTicketPurchaseConfirmationService(props);
  return (
    <PurchaseConfirmation
      approvalPending={service.pendingApproval}
      invoicePayerEmail={service.invoicePaymerEmail}
      entityType={ConfirmationPageEntityType.GET_TICKLET}
      isInvoicePaymentPending={service.invoicePaymentPending}
      ticketStatus={props.state.participantData?.ticketStatus}
      closeHandler={() => props.dismissPurchaseTicketHandler?.()}
      purchaseOrder={props.state.participantData?.regPurchaseOrder}
      myExperienceLoginUrl={props.state.participantData?.myExperienceLoginUrl}
      purchaseOrderTableProps={{
        originatingFormName: props.state.participantData?.registrationForm?.title
      }}
      participantFullName={props.state.participantData ? getFullName(props.state.participantData) : ""}
    />
  );
}
